// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bep_a bih_b bih_va bih_rv bih_rw bih_vu","PanelFooter--link":"bep_b"};